import { Flex } from "grid-styled";
import styled from "styled-components";

export const MainFlex = styled(Flex)`
  width: 960px;
  max-width: 100%;
  margin: 0 auto;
`

export const Img = styled.img`
  width: 100%;
  height: 100%;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/flexes.tsx